import React, { Fragment } from 'react';
import styles from './styles.module.scss';

import { DualCaptureViewerProps } from '..';
import ColoredCaptureStatus from '../../../ColoredCaptureStatus';
import { Hosts } from '../../../../utils/host';

import SensorReannotateButton from '../../../SensorReannotateButton';
import HorizontalForm from '../../../HorizontalForm';
import DetailsButton from '../../../DetailsButton';

const CaptureCardHeader: React.FunctionComponent<{
  sensor: DualCaptureViewerProps['leftSensor'];
  capture: null | DualCaptureViewerProps['leftCapture'];
  seek: number;
}> = ({ sensor, capture, seek }) => (
  <div className={styles.wrapper}>
    <div className={styles.sensorMetadata}>
      <div className={styles.sensorMetadataColumn}>
        <span className={styles.sensorMetadataSerialNumber}>
          <div className={styles.index}>{sensor.index + 1}</div>
          {sensor.serialNumber}
        </span>
        <span className={styles.sensorMetadataDoorwayName}>
          Doorway Name:&nbsp;{sensor.doorwayName}
        </span>
      </div>
      <HorizontalForm>
        { capture ?
          <SensorReannotateButton  captureIds = { [capture.id] } /> : null
        }
        <DetailsButton
          href={`#/${sensor.organizationId}/sensors/${sensor.serialNumber}`}
        />
      </HorizontalForm>
    </div>

    {capture ? (
      <div className={styles.captureMetadata}>
        <span>
          Capture ID:&nbsp;
          <a href={`${Hosts.AnnotationToolHost}/captures/${capture.id}/?t=${seek}`}>
            {capture.id}
          </a>
        </span>
        <ColoredCaptureStatus captureStatus={capture.status} />
      </div>
    ) : <div className={styles.captureMetadata} />}
  </div>
);

export default CaptureCardHeader;
